document.addEventListener('DOMContentLoaded', (event) => {
  /**
   * feedback
   * @description Log the tracking status to the console.
   */
  function feedback() {
    const p = Shopify.customerPrivacy;
    console.log(`Tracking ${p.userCanBeTracked() ? 'en' : 'dis'}abled`);
  }

  /**
   * Shopify.loadFeatures
   * @description Load the Shopify Customer Privacy JavaScript library. With callback.
   */
  Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    (error) => {
      if (error) throw error;
      feedback();
      // In case the cookiebot is already accepted
      handleShopifyTrackingConsent();
      // Set or update tracking when CookiebotOnConsentReady event is triggered
      __cmp('addEventListener', ['consent', handleShopifyTrackingConsent, false], null);
    }
  );

  /**
   * handleShopifyTrackingConsent
   * @description Set the tracking consent so we can load the Shopify Web Pixel.
   */
  function handleShopifyTrackingConsent() {
    var status = __cmp('getCMPData');
    if ('customerPrivacy' in Shopify && 'vendorConsents' in status) {
      // s905 = "Google Tag Manager"
      if ('s905' in status.vendorConsents && status.vendorConsents['s905']) {
        // Vendor s905 has consent
        Shopify.customerPrivacy.setTrackingConsent(true, feedback);
      } else {
        // Vendor s905 does not have consent
        Shopify.customerPrivacy.setTrackingConsent(false, feedback);
      }
    }
    feedback();
  }
});
